import { Link } from "react-router-dom";
import "../../styles/HomeNew.css";
import YGCNav from "../../nav/YGC-Nav";

function MemberCard({ member, index }) {
  const colors = ["lchip--purple", "lchip--pink", "lchip--green"];
  const c = colors[index % 3];
  const bd = c === "lchip--purple" ? "var(--pu-200)" : c === "lchip--pink" ? "var(--pk-200)" : "var(--gn-200)";
  const bg = c === "lchip--purple" ? "var(--pu-50)" : c === "lchip--pink" ? "var(--pk-50)" : "var(--gn-50)";
  return (
    <div style={{
      display: "grid", gridTemplateColumns: "auto 1fr", gap: "1.25rem", alignItems: "flex-start",
      background: "var(--white)", border: "1.5px solid var(--bdr)", borderRadius: "18px", padding: "1.4rem",
      transition: "border-color .2s, box-shadow .2s, transform .2s"
    }}
      onMouseEnter={e => { e.currentTarget.style.borderColor = bd; e.currentTarget.style.boxShadow = "0 6px 24px rgba(0,0,0,.07)"; e.currentTarget.style.transform = "translateY(-2px)" }}
      onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--bdr)"; e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.transform = "translateY(0)" }}>
      <div style={{ width: 80, height: 80, borderRadius: "50%", overflow: "hidden", flexShrink: 0, border: `3px solid ${bd}`, background: bg }}>
        <img src={member.image} alt={member.name} width={80} height={80} loading="lazy"
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          onError={e => { e.target.style.display = "none" }} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: ".4rem" }}>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: ".5rem" }}>
          <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1rem", fontWeight: 800, color: "var(--ink)", lineHeight: 1.2 }}>{member.name}</h3>
          {member.school && <span className={`lcard__chip ${c}`} style={{ fontSize: ".6rem" }}>{member.school}</span>}
        </div>
        {member.bio && <p style={{ fontSize: ".84rem", color: "var(--muted)", lineHeight: 1.75 }}>{member.bio}</p>}
        {member.quote && (
          <p style={{
            fontSize: ".78rem", color: "var(--muted)", lineHeight: 1.6, fontStyle: "italic",
            borderLeft: `3px solid ${bd}`, paddingLeft: ".75rem", marginTop: ".2rem"
          }}>{member.quote}</p>
        )}
      </div>
    </div>
  );
}

function PhotoBlock({ src, caption }) {
  return (
    <div className="lcard" style={{ padding: 0, overflow: "hidden", gap: 0 }}>
      <img src={src} alt={caption || "YGC class photo"} loading="lazy" style={{ width: "100%", display: "block", borderRadius: "14px 14px 0 0" }} />
      {caption && <div style={{ padding: ".85rem 1.1rem" }}><p style={{ fontSize: ".83rem", color: "var(--muted)", lineHeight: 1.65, textAlign: "center" }}>{caption}</p></div>}
    </div>
  );
}

export default function YGCClassPage({ year, logoSrc, photos = [], members = [], wip = false }) {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "38svh" }}>
        <div className="hero__glow hero__glow--1" /><div className="hero__glow hero__glow--2" /><div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker"><Link to="/ygc" style={{ color: "var(--pu-200)", textDecoration: "none", fontWeight: 700 }}>← Youth Global Citizen</Link></p>
            <h1 className="hero__h1">Class of <span className="hero__accent">{year}</span></h1>
            <p className="hero__sub">{wip ? "This class page is coming soon. Check back later for profiles and photos." : `Meet the inspiring young leaders who graduated from FBT's Youth Global Citizen program in ${year}.`}</p>
            {!wip && members.length > 0 && <div className="hero__ctas"><a href="#members" className="cta cta--solid">Meet the Class</a></div>}
          </div>
          <div className="hero__stats">
            {logoSrc && <div className="hstat hstat--soft" style={{ alignItems: "center" }}><img src={logoSrc} alt={`YGC ${year}`} style={{ maxWidth: 140, maxHeight: 70, objectFit: "contain", display: "block" }} /></div>}
            {!wip && members.length > 0 && <div className="hstat hstat--purple"><span className="hstat__n">{members.length}</span><span className="hstat__l">Graduates</span></div>}
            <div className="hstat hstat--green"><span className="hstat__n">{year}</span><span className="hstat__l">Class Year</span></div>
          </div>
        </div>
      </section>

      {/* ── YEAR NAV ── */}
      <div style={{ maxWidth: "var(--max)", marginInline: "auto", padding: "0 var(--pad)" }}>
        <YGCNav />
      </div>

      {/* ── WIP ── */}
      {wip && (
        <section className="local" style={{ maxWidth: "600px", marginInline: "auto" }}>
          <div className="lcard" style={{ background: "var(--pu-50)", borderColor: "var(--pu-200)", alignItems: "center", padding: "2.5rem", gap: "1rem", textAlign: "center" }}>
            <span style={{ fontSize: "2.5rem" }}>🚧</span>
            <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1.2rem", fontWeight: 800, color: "var(--ink)" }}>Coming Soon</h3>
            <p style={{ fontSize: ".9rem", color: "var(--muted)", lineHeight: 1.7 }}>The Class of {year} page is being prepared. Check back soon for graduate profiles and photos.</p>
            <Link to="/ygc" className="lcard__toggle" style={{ textDecoration: "none" }}>← Back to YGC</Link>
          </div>
        </section>
      )}

      {/* ── GROUP PHOTOS ── */}
      {!wip && photos.length > 0 && (
        <section className="local" style={{ maxWidth: "860px", marginInline: "auto", paddingBottom: 0 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
            {photos.map((p, i) => <PhotoBlock key={i} src={p.src} caption={p.caption} />)}
          </div>
        </section>
      )}

      {/* ── MEMBER CARDS ── */}
      {!wip && members.length > 0 && (
        <section id="members" className="local" style={{ maxWidth: "var(--max)", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">Class of {year}</span>
            <h2 className="sec-h2">Graduate Profiles</h2>
            <p className="sec-sub">{members.length} young leaders who completed FBT's Youth Global Citizen program.</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {members.map((m, i) => <MemberCard key={m.name + i} member={m} index={i} />)}
          </div>
        </section>
      )}

    </div>
  );
}